export default __webpack_public_path__ + "static/media/password-show.d3843d53.svg";